import Vue from "vue";
import {
  Button,
  Search,
  Tab,
  Tabs,
  Icon,
  Tabbar,
  TabbarItem,
  NavBar,
  Loading,
  Overlay,
  TreeSelect,
  Swipe,
  SwipeItem,
  Popup,
  Radio,
  RadioGroup,
  Tag,
  Rate,
  DropdownMenu,
  DropdownItem,
  Dialog,
  List,
  Cell,
  PullRefresh,
  Skeleton,
  Field
} from "vant";

export default () => {
  Vue.use(Button);
  Vue.use(Search);
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Icon);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(NavBar);
  Vue.use(Loading);
  Vue.use(Overlay);
  Vue.use(TreeSelect);
  Vue.use(Swipe);
  Vue.use(SwipeItem);
  Vue.use(Popup);
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(Tag);
  Vue.use(Rate);
  Vue.use(DropdownMenu);
  Vue.use(DropdownItem);
  Vue.use(Dialog);
  Vue.use(List);
  Vue.use(Cell);
  Vue.use(PullRefresh);
  Vue.use(Skeleton);
  Vue.use(Field);
};



// WEBPACK FOOTER //
// ./src/js/utils/uiComponent.js